import {
  CompanyName,
  CompanyPhoneNumber,
  FETLIFE_URL,
  FULL_BUSINESS_URL,
} from '../Constants';

export const homePageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} — Dominance, Discipline & Control` },
  {
    property: 'og:description',
    content: `Enter the world of ${CompanyName}. Norfolk-based Dominatrix offering sissy & maid training, ABDL / nursery roleplay, corporal punishment, bondage and remote control.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/favicon/web-app-manifest-192x192.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/` },
  { property: 'og:type', content: 'website' },

  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} — Dominance, Discipline & Control` },
  {
    name: 'twitter:description',
    content: `Private sessions in Norfolk and FMTY. Explore training, discipline, and tailored roleplay with ${CompanyName}.`,
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/favicon/web-app-manifest-192x192.png` },
];

// ----- Structured Data for Home
export const homePageStructuredData = [
  // WebSite entity (recommended on Home)
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: CompanyName,
    url: `${FULL_BUSINESS_URL}/`,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  // WebPage entity for the actual page
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${CompanyName} — Home`,
    url: `${FULL_BUSINESS_URL}/`,
    description: `Welcome to ${CompanyName}. Explore sissy & maid training, ABDL nursery roleplay, corporal punishment, bondage & restraint, and virtual control.`,
    isPartOf: { '@type': 'WebSite', url: `${FULL_BUSINESS_URL}/` },
  },
  // Optional ContactPoint to surface a phone in knowledge panels (safe, minimal)
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: CompanyName,
    url: `${FULL_BUSINESS_URL}/`,
    contactPoint: [{
      '@type': 'ContactPoint',
      telephone: CompanyPhoneNumber,
      contactType: 'Customer Service',
      areaServed: 'GB',
      availableLanguage: ['English'],
    }],
  },
];

export const aboutPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: `${CompanyName} - About Me`,
  url: `${FULL_BUSINESS_URL}/about`,
  description: `Learn more about ${CompanyName}, her approach, and the services she offers. Discover the story behind her work, her philosophy, and what makes her unique in the world of domination.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/about/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: 'Global',
    availableLanguage: ['English'],
  },
};

export const aboutPageAdditionalMeta = [
  { property: 'og:title', content: `About ${CompanyName}` },
  {
    property: 'og:description',
    content: `Explore the world of ${CompanyName}, her unique approach to domination, and the personal philosophy that drives her work. Learn what makes her stand out in the world of BDSM and kink.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-maria-about-image.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/about` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `About ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Get to know ${CompanyName}, her philosophy on BDSM, and the personal experiences that shape her work. Discover what makes her a unique and respected figure in the world of domination.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-maria-about-image.jpg`,
  },
];

export const linksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: `${CompanyName} - Links to Other Platforms`,
  url: `${FULL_BUSINESS_URL}/links`,
  description: `Explore exclusive content from ${CompanyName} across multiple adult platforms. Visit her profiles on various platforms for more personalized content, private interactions, and intimate experiences.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/links/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: 'Global',
    availableLanguage: ['English'],
  },
};

export const linksPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `${CompanyName} - Links to Other Platforms`,
  },
  {
    property: 'og:description',
    content: `Visit ${CompanyName} on various platforms to access her exclusive content, private sessions, and intimate experiences. Links to her profiles on top adult sites included.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-${CompanyName}-links-image.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/links` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `${CompanyName} - Links to Other Platforms`,
  },
  {
    name: 'twitter:description',
    content: `Explore ${CompanyName}’s profiles across various adult sites. Get access to her exclusive content and intimate experiences on different platforms.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-${CompanyName}-links-image.jpg`,
  },
];

export const dominationGalleryStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Domination Gallery`,
  url: `${FULL_BUSINESS_URL}/gallery`,
  description: `Step into the commanding world of ${CompanyName}. Explore a curated visual gallery of seductive control, elegance, and irresistible power.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/gallery?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const dominationGalleryAdditionalMeta = [
  { property: 'og:title', content: `Domination Gallery | ${CompanyName}` },
  {
    property: 'og:description',
    content: `Enter ${CompanyName}'s world of irresistible dominance. Her gallery captures the raw power and visual beauty of female control.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/gallery-preview.png`,
  }, // replace with actual image URL
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Domination Gallery | ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Explore a visual showcase of power, elegance, and seduction in ${CompanyName}'s domination gallery.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/gallery-preview.png`,
  }, // same as og:image
];

export const babyGalleryStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Adult Baby Gallery`,
  url: `${FULL_BUSINESS_URL}/adult-baby`,
  description: `Discover the adult baby world of ${CompanyName} — a unique gallery exploring regression, discipline, and soft submission through sissy play and nappy diaper humiliation.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/adult-baby?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};
export const babyGalleryAdditionalMeta = [
  { property: 'og:title', content: `Adult Baby Gallery | ${CompanyName}` },
  {
    property: 'og:description',
    content: `Step inside the sissy nursery of ${CompanyName}. This gallery showcases adult baby regression, nappy diaper discipline, and soft, humiliating submission.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/adult-baby-gallery-preview.png`,
  }, // update with your preview image
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/adult-baby` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Adult Baby Gallery | ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Explore the sweet, humiliating regression of adult baby and sissy play in ${CompanyName}’s ABDL gallery.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/adult-baby-gallery-preview.png`,
  }, // update to match og:image
];

// Reviews //
// Reviews page
export const reviewsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Reviews`,
  url: `${FULL_BUSINESS_URL}/reviews`,
  description: `Read customer reviews and testimonials about ${CompanyName}'s web and circuit design services. Discover how we’ve helped businesses thrive with our expertise.`,
  sameAs: [`${FETLIFE_URL}`],
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/reviews?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const reviewsPageAdditionalMeta = [
  { property: 'og:title', content: `Customer Reviews | ${CompanyName}` },
  {
    property: 'og:description',
    content: `Explore our customer reviews to see how ${CompanyName} delivers exceptional web and circuit design services.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/reviews` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Customer Reviews | ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `See why customers love ${CompanyName} for web and circuit design services. Read their feedback and experiences.`,
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Booking //
// Booking page
export const bookingPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: `${CompanyName} Booking`,
  serviceType: 'Web and Circuit Design Services Booking',
  provider: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    telephone: CompanyPhoneNumber,
  sameAs: [`${FETLIFE_URL}`],
  },
  areaServed: {
    '@type': 'Country',
    name: 'United Kingdom',
  },
  availableChannel: {
    '@type': 'ServiceChannel',
    serviceUrl: `${FULL_BUSINESS_URL}/booking`,
    availableLanguage: 'English',
  },
  description: `Easily schedule a consultation or service with ${CompanyName} for expert web and circuit design solutions.`,
};

export const bookingPageAdditionalMeta = [
  { property: 'og:title', content: `Book with ${CompanyName}` },
  {
    property: 'og:description',
    content:
      'Schedule your web or circuit design service today with our easy online booking.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/booking` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Book with ${CompanyName}` },
  {
    name: 'twitter:description',
    content: 'Secure your session with our expert team in just a few clicks.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Blog Page
export const blogPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: `${CompanyName} Blog`,
  url: `${FULL_BUSINESS_URL}/blog`,
  description: `Read the latest articles, tips, and insights from ${CompanyName} on web and circuit design.`,
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${FULL_BUSINESS_URL}/blog`,
  },
  sameAs: [`${FETLIFE_URL}`],
};

export const blogPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Blog` },
  {
    property: 'og:description',
    content: 'Stay updated with our latest articles and insights.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/blog` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Blog` },
  {
    name: 'twitter:description',
    content:
      'Read the latest posts on web and circuit design from our experts.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Blog Post Page Structured Data
export const blogPostStructuredData = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: post.title,
  description:
    post.description ||
    `${CompanyName} offers expert web and circuit design insights.`,
  datePublished: post.date || new Date().toISOString(),
  dateModified: post.dateModified || new Date().toISOString(),
  author: {
    '@type': 'Person',
    name: post.author || `${CompanyName}`,
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${FULL_BUSINESS_URL}/blog/${post.slug}`,
  },
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
});

// Blog Post Page Meta Tags
export const blogPostAdditionalMeta = (post) => [
  { property: 'og:type', content: 'article' },
  { property: 'og:title', content: post.title },
  { property: 'og:description', content: post.description || '' },
  {
    property: 'og:image',
    content: post.image || `${FULL_BUSINESS_URL}/brand/logo.png`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/blog/${post.slug}` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: post.title },
  { name: 'twitter:description', content: post.description || '' },
  {
    name: 'twitter:image',
    content: post.image || `${FULL_BUSINESS_URL}/brand/logo.png`,
  },
];

// Forgot password
export const forgottenPasswordPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Reset Password',
  description: `Reset your password for your ${CompanyName} account.`,
  url: `${FULL_BUSINESS_URL}/forgotten-password`,
};

export const forgottenPasswordPageAdditionalMeta = [
  { property: 'og:title', content: `Reset Your Password - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Securely reset your ${CompanyName} account password.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/reset-password-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/forgotten-password` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Reset Your Password - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Follow the steps to securely reset your ${CompanyName} account password.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/reset-password-preview.jpg`,
  },
];

// Login
export const loginPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Login',
  description: `Log in to your ${CompanyName} account to access exclusive features.`,
  url: `${FULL_BUSINESS_URL}/login`,
};

export const loginPageAdditionalMeta = [
  { property: 'og:title', content: `Login - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Access your ${CompanyName} account to explore exclusive features and services.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/login-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/login` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Login - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Sign in to your ${CompanyName} account and unlock access to premium features.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/login-preview.jpg`,
  },
];

// Register
export const registerPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Register',
  description: `Create an account with ${CompanyName} to access exclusive features and services.`,
  url: `${FULL_BUSINESS_URL}/register`,
};

export const registerPageAdditionalMeta = [
  { property: 'og:title', content: `Register - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Sign up for a ${CompanyName} account to enjoy exclusive features and personalized services.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/register-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/register` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Register - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Join ${CompanyName} today and unlock access to premium features.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/register-preview.jpg`,
  },
];

// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Explore the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service, privacy policies, and compliance guidelines of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Learn more about our terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];

export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Person',
    name: 'Mistress Maria',
    url: FULL_BUSINESS_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'worshipmaria@gmail.com',
      contactType: 'Session Inquiries',
      areaServed: 'GB',
      availableLanguage: ['English'],
    },
  sameAs: [`${FETLIFE_URL}`],
    image: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/mistress-maria-profile.jpg`,
    },
  },
};
export const contactPageAdditionalMeta = [
  { property: 'og:title', content: 'Contact Mistress Maria' },
  {
    property: 'og:description',
    content:
      'Reach out to Mistress Maria to request a session or ask a respectful question. Discretion, clarity, and obedience are expected.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-maria-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/contact` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Contact Mistress Maria' },
  {
    name: 'twitter:description',
    content:
      'Use the appropriate form or email to begin your journey with Mistress Maria. Only sincere and respectful inquiries will be considered.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-maria-preview.jpg`,
  },
];

export const tourPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Mistress Maria Tour Dates',
  url: `${FULL_BUSINESS_URL}/tour`,
  performer: {
    '@type': 'Person',
    name: 'Mistress Maria',
  },
  location: {
    '@type': 'Place',
    name: 'Various Locations',
  },
  description:
    'Attend exclusive BDSM and domination sessions with Mistress Maria on her UK tour. Dates and booking details available here.',
  inLanguage: 'English',
};

export const tourPageAdditionalMeta = [
  { property: 'og:title', content: 'Mistress Maria Tour Dates & Bookings' },
  {
    property: 'og:description',
    content:
      'Find upcoming tour dates and book exclusive in-person sessions with Mistress Maria. Don’t miss your chance to submit your request.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-maria-tour.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/tour` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Mistress Maria Tour Dates & Bookings' },
  {
    name: 'twitter:description',
    content:
      'Explore Mistress Maria’s tour schedule and secure your place for unforgettable domination sessions across the UK.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-maria-tour.jpg`,
  },
];

export const howToBookStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'How to Book with Mistress Maria',
  url: `${FULL_BUSINESS_URL}/how-to-book`,
  description:
    'Step-by-step guide to booking appointments with Mistress Maria, including availability, payment options, and booking policies.',
  inLanguage: 'English',
};

export const howToBookAdditionalMeta = [
  {
    property: 'og:title',
    content: 'How to Book Appointments with Mistress Maria',
  },
  {
    property: 'og:description',
    content:
      'Learn how to easily book your BDSM sessions with Mistress Maria. Get all the details on availability, payments, and appointment policies.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/how-to-book.jpg`, // Replace with a relevant image URL
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/how-to-book` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'How to Book Appointments with Mistress Maria',
  },
  {
    name: 'twitter:description',
    content:
      'Step-by-step instructions and important info for booking your session with Mistress Maria smoothly and efficiently.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/how-to-book.jpg`, // Replace with a relevant image URL
  },
];

export const dominatrixFormStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Apply to Serve Mistress Maria',
  url: `${FULL_BUSINESS_URL}/apply-to-serve`,
  description:
    'Complete the Dominatrix application form to serve Mistress Maria. Provide your limits, interests, and personal details to be considered as a submissive.',
  inLanguage: 'English',
};

export const dominatrixFormAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Apply to Serve Mistress Maria – Submissive Application',
  },
  {
    property: 'og:description',
    content:
      'Want to serve Mistress Maria? Submit your submissive application with details about your limits, interests, and availability. All applicants must complete this form.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/dominatrix-application.jpg`, // Update with correct image URL
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/apply-to-serve` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Apply to Serve Mistress Maria – Submissive Application Form',
  },
  {
    name: 'twitter:description',
    content:
      'Fill in the application form to be considered for submission under Mistress Maria. Provide honest and respectful answers to be eligible.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/dominatrix-application.jpg`, // Update with correct image URL
  },
];

export const babyFormStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Adult Baby Application – Serve Mistress Maria',
  url: `${FULL_BUSINESS_URL}/adult-baby-application`,
  description:
    'Submit your Adult Baby application to serve Mistress Maria. Fill out your interests, boundaries, and experience in ABDL play to be considered.',
  inLanguage: 'English',
};

export const babyFormAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Adult Baby Application – Serve Mistress Maria',
  },
  {
    property: 'og:description',
    content:
      'Want to explore your Adult Baby side with Mistress Maria? Submit this form to be considered for ABDL sessions. Honest, detailed responses are required.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/adult-baby-application.jpg`, // Update with appropriate image
  },
  {
    property: 'og:url',
    content: `${FULL_BUSINESS_URL}/adult-baby-application`,
  },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Apply to Be an Adult Baby for Mistress Maria',
  },
  {
    name: 'twitter:description',
    content:
      'Fill in the Adult Baby application form for a chance to serve Mistress Maria in nurturing, discipline, and ABDL play scenarios.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/adult-baby-application.jpg`, // Update with correct image
  },
];

export const dominationServicesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Domination Services – Mistress Maria',
  url: `${FULL_BUSINESS_URL}/domination-services`,
  description:
    'Discover the professional domination services offered by Mistress Maria. Specialising in real-time and online Femdom, she offers intense, tailored sessions for obedient submissives.',
  inLanguage: 'English',
};

export const dominationServicesPageAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Domination Services – Mistress Maria',
  },
  {
    property: 'og:description',
    content:
      'Experience powerful domination services with Mistress Maria. From real-time BDSM to online control, submit and serve under true authority.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/domination-services.jpg`, // Replace with correct image
  },
  {
    property: 'og:url',
    content: `${FULL_BUSINESS_URL}/domination-services`,
  },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Explore Mistress Maria’s Domination Services',
  },
  {
    name: 'twitter:description',
    content:
      'Obey. Submit. Serve. Book a domination session with Mistress Maria—real-time or online. Discipline, control, and obedience await.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/domination-services.jpg`, // Replace with correct image
  },
];

export const adultBabyServicesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Adult Baby Services – Mistress Maria',
  url: `${FULL_BUSINESS_URL}/adult-baby-services`,
  description:
    'Explore Adult Baby and ABDL services with Mistress Maria. From gentle nurturing to strict discipline, sessions are tailored to your regression needs and boundaries.',
  inLanguage: 'English',
};

export const adultBabyServicesPageAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Adult Baby Services – Mistress Maria',
  },
  {
    property: 'og:description',
    content:
      'Discover Mistress Maria’s Adult Baby services. Nurturing care, structured regression, and ABDL discipline tailored to your needs.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/adult-baby-services.jpg`, // Replace with correct image
  },
  {
    property: 'og:url',
    content: `${FULL_BUSINESS_URL}/adult-baby-services`,
  },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Explore ABDL Services with Mistress Maria',
  },
  {
    name: 'twitter:description',
    content:
      'Step into a world of controlled regression. Book Adult Baby and ABDL sessions with Mistress Maria for nurturing, structure, and discipline.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/adult-baby-services.jpg`, // Replace with correct image
  },
];
